import { cva } from 'class-variance-authority';

import s from './Button.module.css';

export const buttonVariants = cva(s.button, {
  defaultVariants: {
    color: 'primary',
    size: 'default',
    variant: 'primary',
  },

  variants: {
    color: {
      alternative: s['button--color-alternative'],
      destructive: s['button--color-destructive'],
      primary: s['button--color-primary'],
      secondary: s['button--color-secondary'],
      success: s['button--color-success'],
      white: s['button--color-white'],
    },

    fullWidth: {
      true: s['button--full-width'],
    },

    size: {
      default: s['button--size-default'],
      middle: s['button--size-middle'],
      small: s['button--size-small'],
      tiny: s['button--size-tiny'],
    },

    variant: {
      gradient: s['button--variant-gradient'],
      light: s['button--variant-light'],
      primary: s['button--variant-primary'],
      transparent: s['button--variant-transparent'],
    },
  },
});
